import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { OwsClientService, OwsServiceErrorResponse } from 'ows-library';
import { VisualizarLaudoRespostaModel } from './visualizar-laudo-resposta.model';
import { AuthorizationServicesEnum } from 'ows-library';
import { PopUpService } from 'app/compartilhado/componentes/pop-up/pop-up.service';

@Injectable()
export class VisualizarLaudoService {
  laudoChanged = new Subject<VisualizarLaudoRespostaModel>();
  localChanged = new Subject<any>();
  fotosVeiculosChanged = new Subject<any>();
  carregando = false;
  dataHoraEmissao: Date;
  laudoVistoriaId;
  empresaCodigo;
  empresaNome = '';
  empresaCnpj = '';
  dadosAdicionaisLaudo;
  caminhoFotoVistoriador = '';

  constructor(private owsClientService: OwsClientService,
    private popUpService: PopUpService) {
  }

  obterLaudo(id: string, laudoNumero: string) {
    this.owsClientService.get<any>('administrativo/laudos/informacoes', {
      authorizationService: AuthorizationServicesEnum.None,
      requestParameters: [
        { key: 'shortId', value: id },
        { key: 'laudoNumero', value: laudoNumero }
      ]
    }).subscribe((response) => {
      if (response.body.mensagemResposta === 'FalhaIp') {
        this.popUpService.showCustomPopWarning('Falha ao consultar!', 'O laudo não está liberado para o IP da solicitação.');
      } else {
        this.laudoVistoriaId = response.body.laudovistoriaid;
        this.caminhoFotoVistoriador = response.body.caminhoFotoVistoriador;
        this.dataHoraEmissao = response.body.visualizarLaudo.DataHoraEmissao;
        this.empresaCodigo = response.body.visualizarLaudo.EmpresaCodigo;
        this.dadosAdicionaisLaudo = response.body.dadosAdicionaisLaudo[0];
        this.empresaNome = response.body.dadosAdicionaisLaudo[0].EmpresaNomeRazaoSocial;
        this.empresaCnpj = response.body.dadosAdicionaisLaudo[0].EmpresaCNPJ;

        if (response.body.mensagemResposta !== '') {
          this.popUpService.showCustomPopWarning('Falha na operação do registro', response.body.mensagemResposta);
        }
        this.laudoChanged.next(response.body.visualizarLaudo);
      }
    },
      error => {
        if (error instanceof Error) {
          this.popUpService.showCustomPopWarning('Erro de conexão', error.message);
        } else if (!error.error) {
          this.popUpService.showCustomPopWarning('Falha na operação do registro.', 'Não foi possível estabelecer conexão com a API.')
        } else {
          this.popUpService.showCustomPopWarning('Falha na operação do registro', (<OwsServiceErrorResponse>error).error.Code + ': ' + (<OwsServiceErrorResponse>error).error.Message);
        }
      });
  }
}
